import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SlackBlocksModule } from '../slack-blocks/slack-blocks.module';
import { UnlayerWrapperComponent } from '../unlayer-wrapper/unlayer-wrapper.component';

import { TemplateEditorComponent } from './template-editor.component';
import { TemplateOptionsPage } from './template-options/template-options.page';
import { TemplatesListComponent } from './templates-list.component';
import { TemplatesRoutingModule } from './templates-routing.module';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, UnlayerWrapperComponent, SlackBlocksModule, TemplatesRoutingModule],
  declarations: [TemplatesListComponent, TemplateEditorComponent, TemplateOptionsPage],
  exports: [TemplatesListComponent, TemplateEditorComponent, TemplateOptionsPage],
})
export class TemplatesModule {}
